import { get as userGet } from 'js/lib/user';

import { useTracker } from '@coursera/event-pulse/react';

import { useNaptime } from 'bundles/naptimejs';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import ProgramEnrollmentsV2 from 'bundles/naptimejs/resources/programEnrollments.v2';
import useEnterpriseBadgeEnrollMutation from 'bundles/skills-common/shared/verified-skills/data/pathway-badge/useEnterpriseBadgeEnrollMutation';

type EnrollmentParams = {
  isEnrolledInPathway: boolean;
  isEnrolledInCourse: boolean;
  programId: string;
  courseId: string;
  pathwayId?: string;
  pathwayCollectionId?: string;
  programSlug?: string;
  thirdPartyOrganizationSlug?: string;
};

const usePathwayAndCourseEnrollmentActions = () => {
  const track = useTracker();
  const enrollInPathway = useEnterpriseBadgeEnrollMutation();
  const { naptime } = useNaptime(() => ({}));

  const executeEnrollments = async (params: EnrollmentParams) => {
    const {
      isEnrolledInPathway,
      isEnrolledInCourse,
      pathwayId,
      programId,
      courseId,
      pathwayCollectionId,
      programSlug,
      thirdPartyOrganizationSlug,
    } = params;

    if (!isEnrolledInPathway && pathwayId) {
      await enrollInPathway({
        user_id: userGet().id,
        badge_template_id: pathwayId,
        request_origin: 'REQUEST_ORIGIN_USER',
      });

      track('click_button', {
        button: { name: 'enroll' },
        enterprise: {
          programSlug,
          organizationSlug: thirdPartyOrganizationSlug,
        },
        product: {
          id: pathwayId,
          type: 'learning_path',
        },
      });
    }

    if (!isEnrolledInCourse) {
      await naptime.executeMutation(
        ProgramEnrollmentsV2.action(
          'enrollInCourse',
          {},
          {
            programId,
            courseId,
            userId: userGet().id.toString(),
            collectionId: pathwayCollectionId,
          }
        )
      );
    }
  };

  return { executeEnrollments };
};

export default usePathwayAndCourseEnrollmentActions;
